<template>
  <div class="c-dmpush-wrapper">
    <!-- filter -->
    <push-filter slot="filter" :media-data="mediaData" :stat-data="statData" @on-change="filterData" />
    <!-- table -->

    <Viewport v-model="tableHeight">
      <el-table ref="table" class="common-el-table-styles" :data="tableData" :height="tableHeight" v-loading="loading">
        <el-table-column
          v-for="(col, id) in tableColumns"
          :key="id"
          :prop="col.key"
          :label="col.title"
          :fixed="col.fixed"
          :show-overflow-tooltip="col.overflow"
          :min-width="col.width"
          :align="col.align"
        >
          <template slot-scope="scope">
            <div v-if="col.key === 'control'" class="m-control">
              <Poptip confirm transfer title="您确认重新推送吗？" @on-ok="pushClick(scope.row)">
                <el-button type="text" v-loading="scope.row._uping">重新推送</el-button>
              </Poptip>
            </div>
            <span v-else-if="col.key.indexOf('Rate') > -1">{{ scope.row[col.key] | toPercent }}</span>
            <span v-else-if="col.key === 'updateTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
            <span v-else>{{ scope.row[col.key] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <Page
        show-total
        show-sizer
        show-elevator
        class="c-table-page pager"
        size="small"
        :total="total"
        :current.sync="pageIndex"
        :page-size="pageSize"
        :page-size-opts="[10, 20, 30, 40, 100]"
        @on-change="changePageIndex"
        @on-page-size-change="changePageSize"
      />
    </Viewport>
  </div>
</template>
<script>
import { isArray } from '@/common/js/utils'
import mixin from '../mixins/mixin'
import mixinPage from '../mixins/mixin_page'
import tableColumns from '../data/push_columns'
import PushFilter from './components/push-filter'

import { getSubPackagePushPage, retrySubPackagePush } from '@/api/manage.model'

export default {
  name: 'DMPush',
  mixins: [mixin, mixinPage],
  components: { PushFilter },
  data() {
    return {
      tableHeight: 330,
      id: this.$route.query && this.$route.query.id,
      loading: null,
      height: 0,
      tableData: [],
      tableColumns: [],
      statData: [
        { id: 1, name: '成功' },
        { id: 2, name: '失败' }
      ],
      mediaData: [
        { id: 10, name: '巨量引擎' },
        { id: 16, name: '腾讯' },
        { id: 32, name: '磁力引擎' },
        { id: 45, name: '百度信息流' }
      ]
    }
  },
  created() {
    this.filterData({})
  },
  methods: {
    getData(filter = {}) {
      const params = {
        id: this.id,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        ...filter
      }
      this.loading = true
      getSubPackagePushPage(params)
        .then((data) => {
          if (typeof data !== 'symbol') {
            this.loading = false
            if (!data) return
            const { list, page_info } = data
            if (isArray(list) && page_info) {
              const { total_number } = page_info
              this.tableColumns = tableColumns
              this.tableData = list
              this.total = total_number || 0
            } else {
              this.tableColumns = []
              this.tableData = []
              this.total = 0
            }
          }
        })
        .catch(() => {
          this.loading = false
          this.tableData = []
          this.tableColumns = []
          this.total = 0
        })
    },
    pushClick(row) {
      if (!row || !row.id) return
      this.$set(row, '_uping', true)
      retrySubPackagePush({ id: row.id }).then((data) => {
        if (typeof data !== 'symbol') {
          this.$set(row, '_uping', false)
          this.getData()
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.c-dmpush-wrapper {
  .c-table-page {
    padding: 5px 0;
    text-align: right;
  }
}
</style>
